/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */

export const DefaultError = 'DefaultError';
export const ReservationRoomReservedError = 'ReservationRoomReservedError';
export const ReservationExpiredError = 'ReservationExpiredError';
export const ReservationNotPossibleError = 'ReservationNotPossibleError';
export const CannotGetRoomDetailsError = 'CannotGetRoomDetailsError';
export const CannotCreateAccountError = 'CannotCreateAccountError';
export const CannotCreateGuestAccount = 'CannotCreateGuestAccount';
export const HostSuccessfullyChangedMessage = 'HostWasSuccessfullyChangedMessage';
export const CannotChangeHostError = 'CannotChangeHostError';
export const RequirementsSuccessfullyUpdatedMessage = 'RequirementsSuccessfullyUpdatedMessage';
export const CannotUpdateRequirementsError = 'CannotUpdateRequirementsError';
export const AccountBlockedError = 'AccountBlockedError';
export const ReservationWillBeCancelledWarning = 'ReservationWillBeCancelledWarning';
export const PleaseCheckTimeOrOtherCentres = 'PleaseCheckTimeOrOtherCentres';

export const errorsLocalizationData = {
  [DefaultError]: [
    '21022019-105513-0024',
    { separator: ' ' },
    '21022019-105513-0031',
    { separator: ' ' },
    '21022019-105513-0026'
  ],
  [ReservationRoomReservedError]: ['21022019-105513-0032', { separator: ' ' }, '21022019-105513-0033'],
  [ReservationExpiredError]: ['21022019-105513-0034', { separator: ' ' }, '21022019-105513-0033'],
  [ReservationNotPossibleError]: ['21022019-105513-0035', { separator: ' ' }, '21022019-105513-0033'],
  [CannotGetRoomDetailsError]: '21022019-105513-0036',
  [CannotCreateAccountError]: '21022019-105513-0037',
  [CannotCreateGuestAccount]: '21022019-105513-0038',
  [HostSuccessfullyChangedMessage]: '21022019-105513-0039',
  [CannotChangeHostError]: '21022019-105513-0040',
  [RequirementsSuccessfullyUpdatedMessage]: '21022019-105513-0041',
  [CannotUpdateRequirementsError]: '21022019-105513-0042',
  [AccountBlockedError]: '06032019-114159-7548',
  [ReservationWillBeCancelledWarning]: '19032019-075548-4328',
  [PleaseCheckTimeOrOtherCentres]: '21022019-105513-0033'
};
